import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P203List_1({ dataTable }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    const normalColumnToFixe = (rowData, checkColumn, titleShow) => {
        const data = { ...rowData };
        const datavalue = data[`${checkColumn}`];

        const _toFixed = parseFloat(datavalue).toFixed(2);
        const _comma = _toFixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                {datavalue && datavalue !== "" && datavalue !== "null" ? _comma : "-"}
            </React.Fragment>
        );
    };

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    emptyMessage="ยังไม่ได้เพิ่มรายการ"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="caseType" header="ลักษณะงาน" body={(e) => normalColumn(e, "caseType", "ลักษณะงาน")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="casePipeSize" header="ขนาด" body={(e) => normalColumn(e, "casePipeSize", "ขนาด")} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="caseQuantityRequest" header="ปริมาณที่ขอ" body={(e) => normalColumn(e, "caseQuantityRequest", "ปริมาณที่ขอ")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="caseUnit" header="หน่วย" body={(e) => normalColumn(e, "caseUnit", "หน่วย")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="caseQuantityReport" header="ปริมาณที่ทำ" body={(e) => normalColumnToFixe(e, "caseQuantityReport", "ปริมาณที่ทำ")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="remark" header="หมายเหตุ" body={(e) => normalColumn(e, "remark", "หมายเหตุ")} style={{ textAlign: "left", width: "20%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                </DataTable>
            </div>
        </div>
    );
}
